import { CategoryEnum, MotorsMetadata } from '@classifieds-sell/datalayer';
import { MotorsDraftFacade } from '@classifieds-sell/state';
import { from, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export abstract class MotorsSectionBase {
    private _sectionbaseDestroyed$: Subject<void> = new Subject<void>();

    public draftLoaded$: Observable<boolean>;

    originalDraftData: any;
    categoryId: CategoryEnum;
    draftData: any;
    validation: any;
    metadata: MotorsMetadata;
    isWithBid: boolean;
    isReserveMet: boolean;
    isListingAfterSevenDays: boolean;


    abstract isValid(): boolean;

    abstract dirty(): boolean;

    constructor(public draftFacade: MotorsDraftFacade) { }

    protected onInit(_subscription?: () => void): void {
        this.draftLoaded$ = this.draftFacade.draftLoaded$;
        this.getDraft(_subscription);
    }

    protected onDestroy(): void {
        this._sectionbaseDestroyed$.next();
    }

    private getDraft(subscription?: () => void): void {
        from(this.draftFacade.state$)
            .pipe(takeUntil(this._sectionbaseDestroyed$))
            .subscribe((state) => {
                if (state?.draftLoaded) {
                    // deep clone to make sure nested properties are still mutable
                    this.draftData = JSON.parse(
                        JSON.stringify(state.draftData)
                    );
                    this.originalDraftData = JSON.parse(
                        JSON.stringify(state.originalDraftData)
                    );
                    this.validation = { ...state.validationSchema };
                    this.metadata = { ...state.metadata };
                    this.categoryId = state.categoryId;
                    this.isWithBid = this.metadata.bidCount > 0;
                    this.isReserveMet = this.metadata.hasReserveMet;
                    this.isListingAfterSevenDays = this.metadata.isListingAfterSevenDays;
                }

                if (
                    this.draftData &&
                    Object.keys(this.draftData).length !== 0 &&
                    this.validation &&
                    Object.keys(this.validation).length !== 0
                ) {
                    // invoke if there is subscription
                    if (subscription) {
                        subscription();
                    }
                }
            });
    }


    publish = (): void => {
        this.draftFacade.updateDraftData(this.draftData);
    };
}
